var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinorMedicalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    height: 113.6,
    viewBox: "0 0 127 113.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6a4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79340"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(-394 -588.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M443.549,604.606a11.409,11.409,0,0,0,11.4,11.4h2.046a1.525,1.525,0,0,1,1.108.478l0-.826s-12.886-.763-12.886-7.32c0-4.145-.247-7.907-2.255-11.308C443.684,599.044,443.549,600.048,443.549,604.606Z",
    fill: "#449bc9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M454.945,619.069a14.479,14.479,0,0,1-14.463-14.463v-4.242a6.807,6.807,0,0,0-11.6-4.807c-30.911,30.911-28.847,29.134-29.769,29.134a1.536,1.536,0,0,1-1.084-2.618l27.755-27.754c-13.24,8.754-30.7,30.415-30.7,30.415l10.326.755,3.413,2.03,5.846.262,5.674,2.308,4.744-1.21,4.566,2.58,10.922-6.645,6.724,2.082,10.834-4.018-.018-4.3C457.454,619.28,456.634,619.069,454.945,619.069Z",
    fill: "#449bc9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 7.067,
    cy: 7.067,
    r: 7.067,
    transform: "translate(449.701 603.495) rotate(-80.783)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M457.28,615.67s12.886-.777,12.886-7.455.544-12.481,7.85-17.2c10.126-6.537,41.018,32.5,41.018,32.5l-9.061,2.168-3.413,2.067-5.846.267-5.674,2.35-4.743-1.232-4.566,2.627L474.808,625l-6.723,2.121-10.835-4.093Z",
    fill: "#449bc9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M442.533,685.656c-.741-.255-1.491-.534-2.228-.829a1.533,1.533,0,0,1,1.139-2.847c.691.277,1.393.538,2.087.776a1.533,1.533,0,0,1-1,2.9Zm-9.3-4.388c-.669-.411-1.34-.846-1.993-1.293a1.533,1.533,0,0,1,1.732-2.531c.612.42,1.24.827,1.866,1.212a1.533,1.533,0,1,1-1.605,2.612Zm-8.122-6.3c-.566-.548-1.126-1.118-1.665-1.693a1.533,1.533,0,0,1,2.239-2.1c.5.538,1.028,1.071,1.558,1.584a1.533,1.533,0,0,1-2.132,2.2Zm-6.567-7.9c-.437-.661-.86-1.338-1.26-2.015a1.533,1.533,0,0,1,2.641-1.559c.373.632.769,1.266,1.176,1.882a1.533,1.533,0,0,1-2.557,1.692Zm-4.7-9.142c-.28-.733-.546-1.486-.79-2.238a1.533,1.533,0,0,1,2.917-.946c.228.7.476,1.405.737,2.09A1.533,1.533,0,0,1,413.848,657.922Zm-2.587-9.947c-.114-.781-.209-1.575-.282-2.36a1.533,1.533,0,0,1,3.053-.286c.068.733.157,1.475.264,2.205a1.533,1.533,0,0,1-3.035.441Zm-.367-10.268c.056-.78.134-1.576.231-2.365a1.533,1.533,0,0,1,3.044.373c-.091.738-.164,1.483-.216,2.212A1.534,1.534,0,0,1,410.894,637.707Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M472.6,682.575c.7-.249,1.393-.518,2.07-.8a1.534,1.534,0,0,1,1.175,2.833c-.723.3-1.468.587-2.213.853A1.533,1.533,0,0,1,472.6,682.575Zm8.635-4.2c.621-.392,1.242-.806,1.847-1.231a1.533,1.533,0,0,1,1.764,2.508c-.646.454-1.311.9-1.976,1.316A1.533,1.533,0,0,1,481.237,678.371Zm7.521-5.981c.52-.514,1.037-1.053,1.538-1.6a1.533,1.533,0,0,1,2.265,2.067c-.537.588-1.091,1.165-1.647,1.715A1.533,1.533,0,0,1,488.758,672.39Zm6.05-7.466c.4-.624.791-1.263,1.156-1.9a1.534,1.534,0,0,1,2.659,1.529c-.391.68-.807,1.364-1.236,2.03A1.533,1.533,0,0,1,494.808,664.924Zm4.287-8.6c.254-.691.494-1.4.713-2.105a1.533,1.533,0,0,1,2.929.908c-.235.757-.492,1.516-.764,2.256A1.533,1.533,0,0,1,499.1,656.322Zm2.3-9.329c.1-.733.175-1.476.235-2.21a1.533,1.533,0,0,1,3.056.25c-.064.784-.149,1.578-.252,2.36A1.533,1.533,0,0,1,501.4,646.993Zm.223-9.613c-.06-.728-.143-1.471-.243-2.207a1.533,1.533,0,0,1,3.038-.414c.108.788.2,1.584.261,2.365a1.533,1.533,0,1,1-3.056.256Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M435.033,608.171a1.521,1.521,0,0,1,0-3.041A1.521,1.521,0,0,1,435.033,608.171Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M456.276,699.983V604.718a1.533,1.533,0,1,1,3.066,0v95.265A1.533,1.533,0,0,1,456.276,699.983Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M457.809,606.251a8.6,8.6,0,1,1,8.6-8.6A8.609,8.609,0,0,1,457.809,606.251Zm0-14.134a5.534,5.534,0,1,0,5.534,5.534A5.54,5.54,0,0,0,457.809,592.117Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M507.154,624.169l-15.042-15.043a1.533,1.533,0,0,1,2.168-2.168L509.322,622a6.42,6.42,0,0,0,7.846.953l-29.023-29.023a9.1,9.1,0,0,0-15.53,6.433v4.242a12.177,12.177,0,0,1-12.163,12.163h-2.769a1.533,1.533,0,0,1,0-3.066h2.769a9.107,9.107,0,0,0,9.1-9.1v-4.242a12.163,12.163,0,0,1,20.764-8.6L520.551,622a1.532,1.532,0,0,1,0,2.168A9.468,9.468,0,0,1,507.154,624.169Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M481.25,617.049a1.533,1.533,0,0,1-1.35-2.256A21.37,21.37,0,0,0,482.444,605a1.534,1.534,0,0,1,3.067.056,24.761,24.761,0,0,1-2.907,11.182A1.534,1.534,0,0,1,481.25,617.049Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M497.914,626.4l-8.3-8.3a1.533,1.533,0,0,1,2.168-2.168l8.3,8.3a6.5,6.5,0,0,0,8.041.908l-11.95-11.949a1.533,1.533,0,0,1,2.168-2.168c14.248,14.247,13.6,13.34,13.6,14.233a1.545,1.545,0,0,1-.51,1.144A9.57,9.57,0,0,1,497.914,626.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M488.715,628.67l-5.3-5.3a1.533,1.533,0,0,1,2.168-2.168l5.3,5.3a6.492,6.492,0,0,0,8.043.91l-9.057-9.055a1.533,1.533,0,0,1,2.168-2.168c11.069,11.067,10.7,10.46,10.7,11.337a1.544,1.544,0,0,1-.509,1.144A9.551,9.551,0,0,1,488.715,628.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M478.3,629.789l-4.139-4.14a1.533,1.533,0,0,1,2.168-2.167c4.172,4.171,5.384,6.039,8.729,6.039a6.45,6.45,0,0,0,3.452-.99l-5.13-5.131a1.533,1.533,0,0,1,2.168-2.168l6.329,6.329C494.492,630.179,484.535,636.026,478.3,629.789Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M394.427,622.42l30.657-30.657a12.163,12.163,0,0,1,20.764,8.6v4.242a9.107,9.107,0,0,0,9.1,9.1h2.769a1.533,1.533,0,0,1,0,3.066h-2.769a12.177,12.177,0,0,1-12.163-12.163v-4.242a9.11,9.11,0,0,0-15.53-6.433L397.81,623.373a6.421,6.421,0,0,0,7.846-.953l15.461-15.462a1.533,1.533,0,0,1,2.168,2.168l-15.461,15.462C401.66,630.752,391.832,625.014,394.427,622.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M403.936,624.14l13.119-13.12a1.533,1.533,0,0,1,2.168,2.168L407.3,625.108a6.5,6.5,0,0,0,8.041-.909l8.268-8.268a1.533,1.533,0,0,1,2.168,2.168l-8.268,8.268C411.268,632.612,401.322,626.754,403.936,624.14Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M413.106,626.442l10.254-10.253a1.533,1.533,0,0,1,2.168,2.168l-9.056,9.055a6.489,6.489,0,0,0,8.042-.91l5.3-5.3a1.533,1.533,0,0,1,2.168,2.168l-5.3,5.3C420.421,634.935,410.5,629.044,413.106,626.442Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M423.523,627.561l6.329-6.329a1.533,1.533,0,0,1,2.168,2.168l-5.13,5.129a6.5,6.5,0,0,0,8.042-.908l4.139-4.139a1.533,1.533,0,0,1,2.168,2.167l-4.139,4.14C430.858,636.03,420.907,630.177,423.523,627.561Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M461.318,642.022c5.929-2.707,8.347-5.012,8.347-7.952a1.533,1.533,0,0,1,3.066,0c0,5.37-4.873,8.336-10.139,10.742A1.534,1.534,0,0,1,461.318,642.022Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M460.688,686.549a1.533,1.533,0,0,1,.4-2.13c3.594-2.445,5.06-4.409,5.06-6.778,0-9.554-22.066-9.668-22.066-21.786,0-5.093,4.531-7.993,8.479-9.953a1.534,1.534,0,0,1,1.362,2.748c-4.748,2.356-6.775,4.511-6.775,7.2,0,4.494,4.945,6.935,10.179,9.519,5.844,2.884,11.887,5.868,11.887,12.267,0,4.369-3.236,7.16-6.4,9.313A1.533,1.533,0,0,1,460.688,686.549Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M457.506,701.8a6.666,6.666,0,0,1-5.608-10.365,1.533,1.533,0,0,1,2.533,1.728c-1.533,2.249-.15,5.571,3.463,5.571a3.711,3.711,0,0,0,3.706-3.706c0-5.483-15.419-7.924-15.419-17.387,0-4.934,3.869-7.828,6.78-9.575a1.533,1.533,0,0,1,1.578,2.629c-3.709,2.226-5.292,4.3-5.292,6.946,0,7.412,15.419,9.389,15.419,17.387A6.793,6.793,0,0,1,457.506,701.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M461.185,663.8c4.239-2.255,7.062-4.468,7.062-7.941,0-9.46-25.578-9.581-25.578-21.785a1.533,1.533,0,0,1,3.066,0c0,9.458,25.578,9.588,25.578,21.785,0,5.311-4.392,8.363-8.688,10.648A1.533,1.533,0,0,1,461.185,663.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M447.387,639.235a4.718,4.718,0,1,1,4.719-4.718A4.724,4.724,0,0,1,447.387,639.235Zm-1.652-4.718a1.653,1.653,0,0,0,3.305,0A1.653,1.653,0,0,0,445.735,634.517Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M468.061,639.235a4.718,4.718,0,1,1,4.718-4.718A4.724,4.724,0,0,1,468.061,639.235Zm-1.652-4.718a1.652,1.652,0,0,0,3.3,0A1.652,1.652,0,0,0,466.409,634.517Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M459.191,624.849a1.916,1.916,0,0,0-3.016,0c-6.764,8.492-22.675.9-22.675-12.253a1.533,1.533,0,0,1,3.066,0c0,10.623,12.577,16.159,17.209,10.344a4.982,4.982,0,0,1,7.813-.006c3.854,4.832,12.237,1.747,15.534-3.952a1.534,1.534,0,0,1,2.1-.558C483.392,620.84,467.3,635.013,459.191,624.849Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinorMedicalActive);
export default __webpack_public_path__ + "static/media/minor-medical-active.82977193f1b12c1af3021476e52d31ea.svg";
export { ForwardRef as ReactComponent };